import { gql } from 'graphql-request'

export const UPDATE_MAIN_MENUS = gql`
  mutation UpdateMainMenus($updateMainMenusInput: [UpdateMainMenusInput!]!) {
    updateMainMenus(updateMainMenusInput: $updateMainMenusInput) {
      id
    }
  }
`
